import Dispatcher from '../../../flux/dispatcher/dispatcher';
import Constants from "../../AuthorisePage/constant/AuthoriseAccountConstant";
// var Dispatcher = require('dispatcher/dispatcher');
var EventEmitter = require('events').EventEmitter;
var RESPONSE_CHANGE_EVENT = 'globalResponse';
// var Constants = require('components/AuthorisePage/constant/AuthoriseAccountConstant');
var assign = require('object-assign');

var response = {};

function parseResponse(resp) {
    response = resp;
}

var GetProfileStore = assign({}, EventEmitter.prototype, {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
    emitChangeEvent: function (event) {
        this.emit(event);
    },
    bind: function (callback) {
        this.on(RESPONSE_CHANGE_EVENT, callback);
    },
    unbind: function (callback) {
        this.removeListener(RESPONSE_CHANGE_EVENT, callback);
    },
    getResponse: function () {
        return response;
    }
});

Dispatcher.register(function (action) {

    switch (action.actionType) {
        case Constants.GET_PROFILE                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      :
            var resp = action.data;
            parseResponse(resp)
            GetProfileStore.emitChangeEvent(RESPONSE_CHANGE_EVENT)
            break;
            
        default:
    }
});

export default GetProfileStore;